import React from "react";
import { IoClose } from "react-icons/io5";
import "./viewCustomer.css";

const ViewCustomer = ({ customerData, onClose }) => {
  if (!customerData) return null;

  return (
    <div className="barrel_view_overlay">
      <div className="barrel_view_modal">
        {/* Header */}
        <div className="barrel_view_header">
          <h4>Customer Details</h4>
          <span className="barrel_view_close_btn" onClick={onClose}>
            <IoClose />
          </span>
        </div>

        {/* Body */}
        <div className="barrel_view_body">
          {/* SAP Code */}
          <div className="barrel_view_group">
            <label>SAP Code (Vendor Code)</label>
            <p>{customerData.sap_code || "-"}</p>
          </div>

          {/* Customer Name */}
          <div className="barrel_view_group">
            <label>Customer Name</label>
            <p>{customerData.customer_name || "-"}</p>
          </div>

          {/* Customer Type */}
          <div className="barrel_view_group">
            <label>Customer Type</label>
            <p>{customerData.customer_type || "-"}</p>
          </div>

          {/* Email */}
          <div className="barrel_view_group">
            <label>Email</label>
            <p>{customerData.email || "-"}</p>
          </div>

          {/* Contact Number */}
          <div className="barrel_view_group">
            <label>Contact Number</label>
            <p>{customerData.contact_number || "-"}</p>
          </div>

          {/* Billing Address */}
          <div className="barrel_view_address_section">
            <h5>Billing Address</h5>
            <div className="barrel_view_address">
              <p>
                {customerData.billing_address_line1 || "-"}{" "}
                {customerData.billing_address_line2 && (
                  <> , {customerData.billing_address_line2}</>
                )}
              </p>
              <p>
                {customerData.billing_city || ""}{" "}
                {customerData.billing_state && (
                  <> , {customerData.billing_state}</>
                )}{" "}
                {customerData.billing_pincode && (
                  <> - {customerData.billing_pincode}</>
                )}
              </p>
            </div>
          </div>

          {/* Shipping Address */}
          <div className="barrel_view_address_section">
            <h5>Shipping Address</h5>
            <div className="barrel_view_address">
              <p>
                {customerData.shipping_address_line1 || "-"}{" "}
                {customerData.shipping_address_line2 && (
                  <> , {customerData.shipping_address_line2}</>
                )}
              </p>
              <p>
                {customerData.shipping_city || ""}{" "}
                {customerData.shipping_state && (
                  <> , {customerData.shipping_state}</>
                )}{" "}
                {customerData.shipping_pincode && (
                  <> - {customerData.shipping_pincode}</>
                )}
              </p>
            </div>
          </div>

          {/* Active Status */}
          <div className="barrel_view_group">
            <label>Status</label>
            <p className={customerData.is_active ? "barrel_view_active" : "barrel_view_inactive"}>
              {customerData.is_active ? "Active" : "Inactive"}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="barrel_view_footer">
          <button className="barrel_view_btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCustomer;